/** Matches CheckLogin — user has an active session. */
export const isLoggedIn = () => localStorage.getItem("session") !== null;
